import { Modal, Button, Row, Col } from "antd";
import startFreeTrial from "../assets/svg/start-free-trial.svg";
import subscriptionMissing from "../assets/svg/subscription-missing.svg";

const TrialModal = ({
  openModal,
  closeModal,
  buttonText = "Start Free Trial",
  modalBody,
  modalWidth,
  redirectToSignup,
  redirect = false,
  title = "",
  isSubscriptionMissing = false,
}) => {
  return (
    <Modal
      title={title}
      width={modalWidth ? modalWidth : modalBody ? 400 : 600}
      closable={true}
      centered
      open={openModal}
      onCancel={closeModal}
      footer={
        modalBody
          ? [
              <Button
                key="submit"
                type="primary"
                className="theme-btn"
                onClick={redirect ? redirectToSignup : closeModal}
              >
                <span className="heading16px">{buttonText}</span>
              </Button>,
            ]
          : []
      }
    >
      <div className="pop-up">
        {modalBody ? (
          modalBody
        ) : (
          <>
            {isSubscriptionMissing ? (
              <div className="tw-flex tw-flex-col tw-items-center tw-py-8">
                <img src={subscriptionMissing} alt="" />

                <div className="tw-text-2xl tw-font-bold tw-text-theme tw-mt-8">
                  Want the full picture?
                </div>
                <div className="tw-text-base tw-text-text-primary tw-mt-1">
                  Subscribe to explore all the details and insights.
                </div>

                <Button
                  key="submit"
                  type="primary"
                  className="main-btn-primary fw-semibold mt20"
                  style={{ height: 42 }}
                  onClick={redirect ? redirectToSignup : closeModal}
                >
                  <span className="tw-text-sm">Subscribe Now</span>
                </Button>
              </div>
            ) : (
              <Row gutter={[20]} className="align-items-center">
                <Col span={11}>
                  <img src={startFreeTrial} alt="" />
                </Col>
                <Col span={13}>
                  <div className="heading29px text-primary-blue fw-bold">
                    Get 10 Free Verified Contacts
                  </div>
                  <div className="fw-bold heading18px">
                    with a BeyondLeadz Pro trial
                  </div>
                  <div>
                    BeyondLeadz Pro customers close deals faster with highly
                    relevant contacts.
                  </div>
                  <Button
                    key="submit"
                    type="primary"
                    className="main-btn-primary fw-semibold mt20"
                    style={{ height: 42 }}
                    onClick={redirect ? redirectToSignup : closeModal}
                  >
                    <span className="heading16px">{buttonText}</span>
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default TrialModal;
